import script from "./object_placeCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./object_placeCollection.vue?vue&type=script&setup=true&lang=js"

import "./object_placeCollection.vue?vue&type=style&index=0&id=49221c98&lang=css"

const __exports__ = script;

export default __exports__